import { storage } from 'react-admin-loopback';
import { API_URL } from '../Configuration';

// TODO: Improve this one
export default (path => `${API_URL}${path}?access_token=${storage.load('lbtoken').id}`)